import React from 'react'
import { Formik, Form } from 'formik'
import {
  InputField,
  InputSelectOptions,
  LoaderButton,
  CurrencyInputField
} from 'components/molecules'
import PropTypes from 'prop-types'
import {
  BANK_TRANSACTION_CATEGORIES,
  BANK_TRANSACTION_CASH_FLOWS
} from 'domains/bank-transaction'
import TlBankSelectSearchField from 'domains/tl-banks/molecules/select-search-field/tl-bank-select-search-field'
import * as Yup from 'yup'
import TimeUtil from 'utils/time-util'

const propTypes = {
  bankTransaction   : PropTypes.object,
  onClickSubmitForm : PropTypes.func.isRequired
}

const validationSchema = Yup.object().shape({
  tl_bank: Yup.object().shape({
    id: Yup.number().required('Required')
  }),
  category      : Yup.string().required('Required'),
  description   : Yup.string().required('Required'),
  cash_flow     : Yup.string().required('Required'),
  amount        : Yup.number().positive('Required').required(),
  transfer_date : Yup.date().required('Required')
})

/**
 * Form to create/edit Finances::BankTransaction data
 * @param {Object} bankTransaction - Finances::BankTransaction
 * @param {Function} onClickSubmitForm - function to submit form
 */

const BankTransactionForm = ({
  bankTransaction,
  onClickSubmitForm
}) => (
  <Formik
    initialValues={{
      id            : bankTransaction?.id,
      tl_bank       : bankTransaction?.tl_bank || '',
      category      : bankTransaction?.category || '',
      description   : bankTransaction?.description || '',
      cash_flow     : bankTransaction?.cash_flow || '',
      amount        : bankTransaction?.amount || '',
      transfer_date : bankTransaction?.transfer_date ? TimeUtil.format(bankTransaction.transfer_date, 'YYYY-MM-DD') : ''
    }}
    enableReinitialize={ true }
    onSubmit={ onClickSubmitForm }
    validationSchema={ validationSchema }
  >
    {
      ({ isSubmitting }) => (
        <Form>
          <TlBankSelectSearchField
            name={ 'tl_bank' }
            label={ 'Bank' }
            required={ true }
            placeholder='Search with Bank name or Account number'
            showRole={ false }
            showDescription={ true }
            formText='Tinkerlust bank yang digunakan untuk proses transaksi debit/credit'
          />

          <InputField
            type='select'
            name={ 'category' }
            label={ 'Category' }
            required={ true }
            formText='category transaksi bank'
          >
            <InputSelectOptions
              options={ BANK_TRANSACTION_CATEGORIES }
            />
          </InputField>

          <InputField
            type='textarea'
            name='description'
            rows='5'
            label='Description'
            required={ true }
            formText='Deskripsi transaksi'
          />

          <InputField
            type='select'
            name={ 'cash_flow' }
            label={ 'Cash Flow' }
            required={ true }
            formText={ 'flow uang masuk/keluar' }
          >
            <InputSelectOptions
              options={ BANK_TRANSACTION_CASH_FLOWS }
            />
          </InputField>

          <CurrencyInputField
            label={ 'Amount' }
            name={ 'amount' }
            required={ true }
            formText='jumlah yang tertera di transaksi debit/credit'
          />

          <InputField
            type='date'
            label={ 'Transfer Date' }
            name={ 'transfer_date' }
            required={ true }
            formText={ 'waktu kapan transaksi di lakukan' }
          />

          <LoaderButton
            color='primary'
            className='mt-auto'
            type='submit'
            disabled={ isSubmitting }
            isLoading={ isSubmitting }
            text='Submit'
          />
        </Form>
      )
    }
  </Formik>
)

BankTransactionForm.propTypes = propTypes

export default BankTransactionForm
